import { createAsyncThunk } from '@reduxjs/toolkit';

import { StatementService } from 'api';

import { StatementData } from 'models';

export const getSecondaryMarketIncome = createAsyncThunk(
	'statement/getSecondaryMarketIncome',
	async (data: StatementData) => {
		return await StatementService.getSecondaryMarketIncome(data);
	},
);
